<template>
  <div class="w-85per dp-inblock">
    <div class="title">
      <h2>신청 개요 / Access Code</h2>
    </div>
    <table class="admin-table-row table-auto">
      <thead>
        <tr>
          <th>고객사</th>
          <td>
            <input
              type="text"
              v-model="companyName"
              @click="openModal()"
              data-toggle="modal"
              data-target="#company_search"
              class="w-20per"
            />
            <button
              class="admin-btn-default ml-05 w-70px"
              @click="openModal()"
              data-toggle="modal"
              data-target="#company_search"
            >
              검색
            </button>
          </td>
        </tr>
        <tr>
          <th>고객사 직접입력</th>
          <td>
            <input type="text" v-model="companyNameDirect" class="w-20per" />
            <span class="txt-13px ml-10"
              >* 고객사 DB에 등록된 고객사명과 다른 경우 입력해주세요.</span
            >
          </td>
        </tr>
        <tr>
          <th>고객사 코드</th>
          <td>
            <input
              type="text"
              v-model="companyCode"
              @keyup.enter="checkOverlap()"
              class="w-20per"
            />
            <button type="button" class="ml-05" @click="checkOverlap()">
              중복 확인
            </button>
            <span class="txt-13px ml-10"
              >* 4자 이상 10자 이하 영소문자, 숫자만 입력 가능합니다.</span
            >
            <br />
            <span class="txt-13px"
              >* 수강신청 URL로 사용됩니다. ex) {{ previewUrl }}/lnk/<span
                style="font-weight: bold"
                >carrot</span
              ></span
            >
          </td>
        </tr>
        <tr>
          <th>고객사 로고</th>
          <td>
            <p class="dp-inblock">
              <label for="logo">
                <input
                  type="radio"
                  value="S"
                  v-model="logoType"
                  name=""
                  id=""
                />
                <span class="ml-05">
                  <img
                    v-if="defaultLogoUrl === ''"
                    src="https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png"
                    alt="ci"
                    class="h-15px"
                  />
                  <img v-else :src="defaultLogoUrl" alt="ci" class="h-20px" />
                </span>
              </label>
            </p>
            <p class="dp-inblock ml-20 mr-20">
              <label for="logo">
                <input
                  type="radio"
                  value="F"
                  v-model="logoType"
                  name=""
                  id=""
                />
                <span class="ml-05">
                  <button
                    type="button"
                    :disabled="logoType !== 'F'"
                    name="fileUpload"
                    @click="$refs.file.click()"
                  >
                    파일 선택
                  </button>
                  <input
                    v-show="false"
                    ref="file"
                    accept=".pdf,.jpg,.jpeg,.png,.gif"
                    type="file"
                    id="companyLogo"
                    name="companyLogo"
                    @change="selectLogoFile($event)"
                  />
                  <span
                    class="ml-10"
                    style="cursor: pointer"
                    @click="detailFile()"
                    >{{ selectedLogoFileName }}</span
                  >
                </span>
              </label>
            </p>
            <p class="dp-inblock ml-20 mr-20 font-13">
              <input type="radio" value="N" v-model="logoType" name="" id="" />
              <span class="ml-05"> 로고 미 사용 </span>
            </p>
            <p class="mt-10">
              <span class="txt-13px">
                * 파일선택으로 등록한 로고는 그 회사의 기본로고가 됩니다. <br />
              </span>
              <span class="txt-13px">
                * 기본 로고로 등록되면 다음 수강신청 제작 시 기본 로고를 계속
                사용할 수 있습니다.<br />
              </span>
              <span class="txt-13px">
                * 파일선택시 1MB 이하만 등록 가능합니다. </span
              ><br />
              <span class="txt-13px">
                * 로고는 최소 높이 <span class="bold">30px(픽셀)</span>에 맞춰서
                적용됩니다.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <th>LMS 담당자 노출</th>
          <td>
            <label>
              <input type="radio" v-model="lmsView" value="Y" name="lmsView" />
              <span class="txt-13px ml-05 mr-20">노출</span>
            </label>
            <label>
              <input type="radio" v-model="lmsView" value="N" name="lmsView" />
              <span class="txt-13px ml-05 mr-20">비노출</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>수강신청 명</th>
          <td>
            <input
              type="text"
              v-model="sugangName"
              class="w-30per"
              maxlength="30"
              placeholder="30자 이내로 입력해주세요"
            />
            <span class="txt-13px ml-10"
              >* 수강신청 관리에만 노출되는 이름입니다. (학습자단 노출X)</span
            >
          </td>
        </tr>
        <tr>
          <th>수강신청 기간</th>
          <td>
            <!-- 2022-10-26 수강신청 사용 : N, 사용안함: Y -->
            <label for="sugang_always_signup_YN1">
              <input
                type="radio"
                v-model="sugang_always_signup_YN"
                value="N"
                id="sugang_always_signup_YN1"
              />
              <span class="txt-13px ml-05 mr-20">사용</span>
            </label>
            <label for="sugang_always_signup_YN2">
              <input
                type="radio"
                v-model="sugang_always_signup_YN"
                value="Y"
                id="sugang_always_signup_YN2"
              />
              <span class="txt-13px ml-05 mr-20">사용 안함</span>
            </label>
            <span v-show="is_sugang_date()">
              <itm-datepicker
                v-model="startEvalDate"
                :parentDate="startEvalDate"
                format="yyyy-MM-dd"
                :language="$store.state.ko"
              ></itm-datepicker>
              <label for="sHour">
                <select
                  v-model="starthh"
                  name="sHour"
                  id=""
                  class="w-80px ml-05"
                >
                  <option
                    v-for="index in 24"
                    :key="index"
                    :value="plusZero((index - 1).toString())"
                  >
                    {{ plusZero((index - 1).toString()) }}
                  </option>
                </select>
              </label>
              :
              <label for="sMinute">
                <select v-model="startmm" name="sMinute" id="" class="w-80px">
                  <option
                    v-for="index in 60"
                    :key="index"
                    :value="plusZero((index - 1).toString())"
                  >
                    {{ plusZero((index - 1).toString()) }}
                  </option>
                </select>
              </label>
              ~
              <itm-datepicker
                v-model="endEvalDate"
                :parentDate="endEvalDate"
                format="yyyy-MM-dd"
                :language="$store.state.ko"
              ></itm-datepicker>
              <label for="eHour">
                <select v-model="endhh" name="eHour" id="" class="w-80px ml-05">
                  <option
                    v-for="index in 24"
                    :key="index"
                    :value="plusZero((index - 1).toString())"
                  >
                    {{ plusZero((index - 1).toString()) }}
                  </option>
                </select>
              </label>
              :
              <label for="eMinute">
                <select v-model="endmm" name="eMinute" id="" class="w-80px">
                  <option
                    v-for="index in 60"
                    :key="index"
                    :value="plusZero((index - 1).toString())"
                  >
                    {{ plusZero((index - 1).toString()) }}
                  </option>
                </select>
              </label>
            </span>
          </td>
        </tr>

        <tr>
          <th>신청자 수강취소</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="cancleYn"
                value="Y"
                name="cancle-Yn"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">사용</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="cancleYn"
                value="N"
                name="cancle-Yn"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">사용 안함</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>신청자수 제한</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="limitWay"
                value="N"
                name="limitWay"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-20">제한없음</span>

            <label for="cancle">
              <input
                type="radio"
                v-model="limitWay"
                value="P"
                name="limitWay"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-05">프로그램 선착순 제한</span>
            <input
              class="mr-05"
              type="number"
              v-model="limit_num"
              v-if="limitWay == 'P'"
              style="width: 50px"
            />
            <span class="txt-13px ml-05 mr-05" v-if="limitWay == 'P'">
              <label for="cancle">
                <input
                  type="radio"
                  v-model="wait_YN"
                  value="Y"
                  name="wait_YN"
                  id=""
                />
              </label>
              대기자 받음
              <input
                class="mr-10"
                type="number"
                v-model="wait_num"
                style="width: 50px"
              />
              <label for="cancle">
                <input
                  type="radio"
                  v-model="wait_YN"
                  value="N"
                  name="wait_YN"
                  id=""
                />
              </label>
              대기자 없음
            </span>

            <label for="cancle ml-10">
              <input
                type="radio"
                v-model="limitWay"
                value="S"
                name="limitWay"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-20">과정별 선착순 제한</span>
            <span class="font-13 ml-05"
              >* 제한없음, 프로그램 선착순 제한 설정시 하위 모든 과목에
              적용.</span
            >
          </td>
        </tr>
        <tr>
          <th>대기인원 화면 노출여부</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="wait_num_YN"
                value="Y"
                name="wait_num_YN"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-20">대기인원 노출</span>

            <label for="cancle">
              <input
                type="radio"
                v-model="wait_num_YN"
                value="N"
                name="wait_num_YN"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-05">대기인원 노출X</span>
          </td>
        </tr>
        <tr>
          <th>프로그램 중복신청</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                :disabled="isFix"
                v-model="programDupYn"
                value="Y"
                name="programDupYn"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-20">중복 가능</span>
            <label for="cancle">
              <input
                type="radio"
                :disabled="isFix"
                v-model="programDupYn"
                value="N"
                name="programDupYn"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">중복 불가</span>
            </label>
            <span class="font-13 ml-05"
              >* 추후 추가되는 프로그램에서도 같은 값이 적용되며, 프로그램이 2개
              이상일 경우 수정이 불가합니다.</span
            >
          </td>
        </tr>
        <tr>
          <th>신청결과 알림설정</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                :disabled="isFix"
                v-model="applyResultAlarmYn"
                value="Y"
                name="applyResultAlarmYn"
                id=""
              />
            </label>
            <span class="txt-13px ml-05 mr-20">알림 받음</span>
            <label for="cancle">
              <input
                type="radio"
                :disabled="isFix"
                v-model="applyResultAlarmYn"
                value="N"
                name="applyResultAlarmYn"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">알림 받지 않음</span>
            </label>
            <span class="font-13 ml-05"
              >* 담당 매니저가 신청 결과를 메일로 받습니다.</span
            >
          </td>
        </tr>
        <tr>
          <th>HQ매니저</th>
          <td>
            <label for="">
              <select
                name=""
                v-model="selectHqManager"
                id=""
                @change="changeHQManager(selectHqManager)"
                class="w-200px"
              >
                <option>선택</option>
                <option
                  v-for="(item, index) of hqManagers"
                  :key="index"
                  :value="item"
                >
                  {{ item.name }}
                </option>
              </select>
            </label>
          </td>
        </tr>
        <tr>
          <th>수강신청 문의</th>
          <td>
            <div>
              <label for="">
                <select name="" id="" v-model="qaAdminData" class="w-200px">
                  <option value="">선택</option>
                  <option
                    v-for="(item, index) of hqManagers"
                    :key="index"
                    :value="item"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </label>
              <button
                class="admin-btn-default ml-05 w-70px"
                @click="addClassQna()"
              >
                추가
              </button>
            </div>
            <div class="mt-10" v-for="(item, index) of qaList" :key="index">
              <input
                type="text"
                v-model="item.qaAdminInfo"
                class="w-60per"
                :disabled="item.rowType === 1"
              />
              <button
                class="btn btn-line-red ml-05 w-70px"
                @click="delClassQna(index)"
              >
                삭제
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th>Access Code</th>
          <td>
            <input
              type="text"
              v-model="accessCode"
              class="w-300px"
              placeholder="Code를 입력해주세요"
            />
          </td>
        </tr>
        <tr>
          <th>Access Code<br />사용 여부</th>
          <td>
            <label class="txt-13px mr-05">
              <input
                type="radio"
                name="accessCodePass"
                value="N"
                v-model="accessCodePass"
              />&nbsp;사용
            </label>
            <label class="txt-13px ml-20">
              <input
                type="radio"
                name="accessCodePass"
                value="Y"
                v-model="accessCodePass"
              />&nbsp;미사용
            </label>
          </td>
        </tr>
        <!-- <tr>
                <th>고객담당자 확인</th>
                <td>
                    <label for="cancle">
                        <input type="radio" v-model="managerYn" value="Y" name="managerYn">
                        <span class="txt-13px ml-05 mr-20">가능</span>
                    </label>
                    <label for="cancle">
                        <input type="radio" v-model="managerYn" value="N" name="managerYn">
                        <span class="font-13 ml-05 mr-20">불가</span>
                    </label>
                    <span class="font-13 ml-05">* ITM HR담당자가 해당 계정으로 HRD에서 신청내역 확인할 수 있습니다.</span>
                </td>
            </tr> -->
        <tr>
          <th>Point Color</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="pointColor"
                value="Blue"
                name="pointColor"
                id=""
              />
              <span class="txt-13px ml-05 mr-20 txt-blue bold">Blue</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="pointColor"
                value="Red"
                name="pointColor"
                id=""
              />
              <span class="font-13 ml-05 mr-20 txt-red bold">Red</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="pointColor"
                value="Green"
                name="pointColor"
                id=""
              />
              <span class="font-13 ml-05 mr-20 txt-green bold">Green</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>메인 배경</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="mainType"
                value="S"
                name="sample"
                id=""
              />
              <span class="font-13 ml-05 mr-20">샘플</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="mainType"
                value="F"
                name="file"
                id=""
              />
              <span class="font-13 ml-05 mr-20">파일첨부</span>
              <span class="ml-05" v-if="mainType === 'F'">
                <button
                  type="button"
                  name="fileUpload"
                  @click="$refs.mainfile.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="mainfile"
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  type="file"
                  @change="selectMainFile($event)"
                />
                <span
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                  @click="detailFile()"
                  >{{ selectedMainFileName }}</span
                >
              </span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="mainType"
                value="N"
                name="no"
                id=""
              />
              <span class="font-13 ml-05">사용안함</span>
            </label>
            <!-- 메인 배경 선택 시 노출 -->
            <div v-if="mainType === 'S'" class="sample-background mt-10 mb-10">
              <ul>
                <li>
                  <img
                    src="https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg"
                    @click="
                      regSampleMain(
                        'https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg',
                        '1'
                      )
                    "
                    class="pointer"
                    :class="{ 'border-blue': selectSampleMain === '1' }"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="https://kr.object.ncloudstorage.com/itmsugang/main/global_main2.jpg"
                    @click="
                      regSampleMain(
                        'https://kr.object.ncloudstorage.com/itmsugang/main/global_main2.jpg',
                        '2'
                      )
                    "
                    class="pointer"
                    :class="{ 'border-blue': selectSampleMain === '2' }"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="https://kr.object.ncloudstorage.com/itmsugang/main/global_main3.jpg"
                    @click="
                      regSampleMain(
                        'https://kr.object.ncloudstorage.com/itmsugang/main/global_main3.jpg',
                        '3'
                      )
                    "
                    class="pointer"
                    :class="{ 'border-blue': selectSampleMain === '3' }"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="https://kr.object.ncloudstorage.com/itmsugang/main/global_main4.jpg"
                    @click="
                      regSampleMain(
                        'https://kr.object.ncloudstorage.com/itmsugang/main/global_main4.jpg',
                        '4'
                      )
                    "
                    class="pointer"
                    :class="{ 'border-blue': selectSampleMain === '4' }"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="https://kr.object.ncloudstorage.com/itmsugang/main/global_main5.jpg"
                    @click="
                      regSampleMain(
                        'https://kr.object.ncloudstorage.com/itmsugang/main/global_main5.jpg',
                        '5'
                      )
                    "
                    class="pointer"
                    :class="{ 'border-blue': selectSampleMain === '5' }"
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </td>
        </tr>

        <!-- 추가된 항목들 -->
        <tr>
          <th>다운로드 파일1</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="isDownload1"
                value="Y"
                name="isDownload1"
                id=""
              />
              <span class="font-13 ml-05 mr-20">파일첨부</span>
              <span class="ml-05" v-if="isDownload1 === 'Y'">
                <input type="text" v-model="downloadFile1Name" class="mr-10" />
                <button
                  type="button"
                  name="fileUpload"
                  @click="$refs.downloadFile1.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="downloadFile1"
                  accept=".pdf, .doc, .docx, .rtf"
                  type="file"
                  @change="selectUploadFile($event, 'downloadFile1')"
                />
                <span
                  v-if="download_file1_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <a
                    :href="download_file1_url"
                    class="admin-btn-default-samll"
                    download
                    target="_blank"
                    >다운로드파일1</a
                  >
                </span>
              </span>
            </label>
            <label for="cancle" class="ml-10">
              <input
                type="radio"
                v-model="isDownload1"
                value="N"
                name="isDownload1"
                id=""
              />
              <span class="font-13 ml-05">사용안함</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>다운로드 파일2</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="isDownload2"
                value="Y"
                name="isDownload2"
                id=""
              />
              <span class="font-13 ml-05 mr-20">파일첨부</span>
              <span class="ml-05" v-if="isDownload2 === 'Y'">
                <input type="text" v-model="downloadFile2Name" class="mr-10" />
                <button
                  type="button"
                  name="fileUpload"
                  @click="$refs.downloadFile2.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="downloadFile2"
                  accept=".pdf, .doc, .docx, .rtf"
                  type="file"
                  @change="selectUploadFile($event, 'downloadFile2')"
                />
                <span
                  v-if="download_file2_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <a
                    :href="download_file2_url"
                    target="_blank"
                    class="admin-btn-default-samll"
                    download
                    >다운로드파일2</a
                  >
                </span>
              </span>
            </label>
            <label for="cancle" class="ml-10">
              <input
                type="radio"
                v-model="isDownload2"
                value="N"
                name="isDownload2"
                id=""
              />
              <span class="font-13 ml-05">사용안함</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>다운로드 파일3</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="isDownload3"
                value="Y"
                name="isDownload3"
                id=""
              />
              <span class="font-13 ml-05 mr-20">파일첨부</span>
              <span class="ml-05" v-if="isDownload3 === 'Y'">
                <input type="text" v-model="downloadFile3Name" class="mr-10" />
                <button
                  type="button"
                  name="fileUpload"
                  @click="$refs.downloadFile3.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="downloadFile3"
                  accept=".pdf, .doc, .docx, .rtf"
                  type="file"
                  @change="selectUploadFile($event, 'downloadFile3')"
                />
                <span
                  v-if="download_file3_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <a
                    :href="download_file3_url"
                    target="_blank"
                    class="admin-btn-default-samll"
                    download
                    >다운로드파일3</a
                  >
                </span>
              </span>
            </label>
            <label for="cancle" class="ml-10">
              <input
                type="radio"
                v-model="isDownload3"
                value="N"
                name="isDownload3"
                id=""
              />
              <span class="font-13 ml-05">사용안함</span>
            </label>
          </td>
        </tr>

        <tr>
          <th>swipe 선택</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="isSwipe"
                value="Y"
                name="swipe_file"
                id=""
              />
              <span class="font-13 ml-05 mr-20">사용</span>
            </label>
            <label for="cancle">
              <input type="radio" v-model="isSwipe" value="N" name="no" id="" />
              <span class="font-13 ml-05">사용안함</span>
            </label>
            <br />
            <span class="txt-red"> * 권장사이즈: 206x328 비율 </span>
          </td>
        </tr>

        <tr v-if="isSwipe === 'Y'">
          <th>swipe 파일1</th>
          <td>
            <label for="cancle">
              <span class="ml-05">
                <button
                  type="button"
                  name="swipeFile1"
                  @click="$refs.swipeFile1.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="swipeFile1"
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  type="file"
                  @change="selectUploadFile($event, 'swipeFile1')"
                />
                <span
                  v-if="swipe_file1_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <img :src="swipe_file1_url" class="preview-img" />
                </span>
              </span>
            </label>
          </td>
        </tr>
        <tr v-if="isSwipe === 'Y'">
          <th>swipe 파일2</th>
          <td>
            <label for="cancle">
              <span class="ml-05">
                <button
                  type="button"
                  name="swipeFile2"
                  @click="$refs.swipeFile2.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="swipeFile2"
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  type="file"
                  @change="selectUploadFile($event, 'swipeFile2')"
                />
                <span
                  v-if="swipe_file2_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <img :src="swipe_file2_url" class="preview-img" />
                </span>
              </span>
            </label>
          </td>
        </tr>
        <tr v-if="isSwipe === 'Y'">
          <th>swipe 파일3</th>
          <td>
            <label for="cancle">
              <span class="ml-05">
                <button
                  type="button"
                  name="swipeFile3"
                  @click="$refs.swipeFile3.click()"
                >
                  파일 선택
                </button>
                <input
                  v-show="false"
                  ref="swipeFile3"
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  type="file"
                  @change="selectUploadFile($event, 'swipeFile3')"
                />
                <span
                  v-if="swipe_file3_url"
                  class="ml-10 mr-10"
                  style="cursor: pointer"
                >
                  <img :src="swipe_file3_url" class="preview-img" />
                </span>
              </span>
            </label>
          </td>
        </tr>

        <tr>
          <th>안내문구</th>
          <td>
            <div class="h-50px">
              <button
                class="btn-line-default defaulte float-right mb-10"
                @click="insertDefaultTag()"
              >
                기본 문구 삽입
              </button>
            </div>

            <ck-editor
              :parentData="infoMessage"
              v-model="infoMessage"
            ></ck-editor>
          </td>
        </tr>
      </thead>
    </table>
    <search-modal
      v-if="isModalOpened"
      @select="selectCompany"
      @close="closeModal"
    ></search-modal>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
      <button class="admin-btn-default" @click="prev()">이전</button>
      <button class="admin-btn-default float-right ml-05" @click="next()">
        다음
      </button>
      <button class="admin-btn-default float-right ml-05" @click="save()">
        저장
      </button>
      <button class="admin-btn-default float-right" @click="preview()">
        미리보기
      </button>
    </div>
  </div>
</template>

<script>
import CkEditor from "@/components/utils/ckEditor.vue";
import SearchModal from "@/components/reg/input/searchModal.vue";
import { EmptyCheck } from "@/utils/validation.js";

export default {
  components: {
    SearchModal,
    CkEditor,
  },
  data: () => ({
    infoMessage: {}, // 에디터 default 내용

    accessCode: "", // 엑세스 코드
    accessCodePass: "N", //엑세스 코드 사용 여부 Y : 미사용,N : 사용
    cancleYn: "Y", // 신청자 수강취소 사용 여부
    idxItmSugangCompany: "", // 고객사 idx
    companyName: "", // 고객사 명
    companyNameDirect: "", // 고객사 명 직접입력
    companyCode: "", // 고객사 코드
    sugangName: "", // 수강신청 명
    managerYn: "Y", // 고객담당자 확인 가능 여부
    lmsView: "Y", // LMS 담당자 노출 여부 Y: 노출, N: 비노출
    pointColor: "Blue", // 수강신청 사용 컬러 Blue, Red, Green, Grey 중 택 1
    logoType: "S", // 로고 타입
    mainType: "S", // 메인 배경 타입
    idx: -1, // 불러오기 위한 mainIdx
    programDupYn: "Y", // 프로그램 중복신청 여부
    applyResultAlarmYn: "N", // 신청결과 알림설정 여부
    limitWay: "N",
    limit_num: 0,
    wait_YN: "Y",
    wait_num: 0,
    wait_num_YN: "Y",
    isSwipe: "N",
    isDownload1: "N",
    isDownload2: "N",
    isDownload3: "N",
    downloadFile1Name: "신청서 다운로드",
    downloadFile2Name: "과정 소개서 다운로드",
    downloadFile3Name: "CARROT 커리큘럼 맵 다운로드",

    isCheckedOverlap: false, // 고객사 코드 중복체크 확인 여부
    overlapCompanyCode: "", // 고객사 코드 변경시 이전값과 같은지 비교값

    logo: "default", // 로고 타입
    defaultLogoUrl: "", // 고객사 로고 있는 경우에 이미지 주소 할당

    isModalOpened: false,

    selectedLogoFiles: "", // 선택된 로고 파일
    completeLogoFile: "", // api에 넣을 로고 파일 데이터
    selectedLogoFileName: "", // 선택된 로고 파일 이름
    selectSampleMain: "4", // 선택된 샘플 로고 번호
    selectedMainFiles: "", // 선택된 메인 배경 파일
    completeMainFile: "", // api에 넣을 메인 배경 파일 데이터
    selectedMainFileName: "", // 선택된 메인 배경 파일 이름

    company_logo_file_url: "", // 회사 로고 url
    main_file_url:
      "https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg", // 메인 배경 파일 url

    // Download 1, 2, 3 업로드용
    download_file1_url: "",
    download_file2_url: "",
    download_file3_url: "",

    // Download 화면용
    selectedDownloadFile1Name: "",
    selectedDownloadFile2Name: "",
    selectedDownloadFile3Name: "",

    // Swipe 1, 2, 3 업로드용
    swipe_file1_url: "",
    swipe_file2_url: "",
    swipe_file3_url: "",

    // Swipe 화면용
    selectedSwipeFile1Name: "",
    selectedSwipeFile2Name: "",
    selectedSwipeFile3Name: "",

    startEvalDate: "", // 수강신청기간 시작 YYYY-MM-DD
    endEvalDate: "", // 수강신청기간 끝 YYYY-MM-DD

    starthh: "00", // 수강신청기간 시작 시간
    startmm: "00", // 수강신청기간 시작 분
    endhh: "00", // 수강신청기간 끝 시간
    endmm: "00", // 수강신청기간 끝 분

    sugang_always_signup_YN: "N", //상시 신청 여부

    qaList: [], // 수강신청 문의 추가, 삭제를 위한 배열
    qaAdmin: "", // HQ매니저 이름
    qaAdminData: "", // 선택된 HQ매니저 데이터
    qaAdminIdx: "", // 선택된 HQ매니저 idx
    qaAdminInfo: "", // HQ매니저 상세 정보 (String)

    hqManagers: [], // HQ매니저 전체 리스트 정보
    selectHqManager: {}, // 선택된 HQ 담당자 정보
    hqNameMng: "", // 선택된 HQ 담당자명
    idxItmSugangEmpMng: "", // 선택된 HQ 담당자명 idx
    loginIdxItmSugangEmpMng: "", // 현재 로그인된 관리자의 HQ idx

    isSaved: false, // 저장됬는지 확인 여부(저장되야 미리보기 할 수 있게끔)
    isFix: false,
    isFetching: false, // 현재 api 로딩중인지

    previewUrl: "", //
  }),

  created() {
    this.previewUrl = this.axios.preview.replace("https://", "");
  },

  mounted() {
    if (sessionStorage.getItem("fix")) {
      this.isFix = false;
      var pageIdx = sessionStorage.getItem("pageIdx");
      var params = {
        pageIdx: pageIdx,
      };
      this.axios
        .get(
          this.axios.root + this.axios.port + `/sugang/summary/${pageIdx}`,
          params
        )
        .then((res) => {
          this.limitWay = res.data.summaryInfo.limit_way;
          this.limit_num = res.data.summaryInfo.limit_num;
          this.wait_YN = res.data.summaryInfo.wait_YN;
          this.wait_num = res.data.summaryInfo.wait_num;
          this.wait_num_YN = res.data.summaryInfo.wait_num_YN;

          console.log("res", res);
          this.idx = res.data.summaryInfo.idx;
          sessionStorage.setItem("mainIdx", this.idx);
          this.qaAdminIdx = res.data.summaryInfo.qa_admin_idx;
          this.hqNameMng = res.data.summaryInfo.hq_name_mng;
          this.idxItmSugangEmpMng = res.data.summaryInfo.idx_itm_sugang_emp_mng;
          this.companyName = res.data.summaryInfo.company_name_direct;
          this.companyNameDirect = res.data.summaryInfo.company_name_direct;
          this.companyCode = res.data.summaryInfo.company_code;
          this.sugangName = res.data.summaryInfo.sugang_name;
          this.cancleYn = res.data.summaryInfo.cancle_YN;
          this.accessCode = res.data.summaryInfo.access_code;
          this.managerYn = res.data.summaryInfo.manager_YN;
          this.lmsView = res.data.summaryInfo.lms_view || "Y";
          this.pointColor = res.data.summaryInfo.point_color;
          this.infoMessage = res.data.summaryInfo.info_message;
          this.programDupYn = res.data.summaryInfo.program_dup_YN;
          this.applyResultAlarmYn = res.data.summaryInfo.apply_result_alarm_YN;
          this.accessCodePass = res.data.summaryInfo.access_code_pass;

          var startEvalDate = res.data.summaryInfo.sugang_start_date.split(" ");
          var endEvalDate = res.data.summaryInfo.sugang_end_date.split(" ");

          var startTime = startEvalDate[1].split(":");
          var endTime = endEvalDate[1].split(":");

          this.startEvalDate = startEvalDate[0];
          this.endEvalDate = endEvalDate[0];

          this.starthh = startTime[0];
          this.startmm = startTime[1];
          this.endhh = endTime[0];
          this.endmm = endTime[1];

          this.mainType = res.data.summaryInfo.main_type;
          this.logoType = res.data.summaryInfo.logo_type;

          if (this.mainType === "F") {
            this.selectedMainFileName = res.data.summaryInfo.main_file_name;
          }

          if (this.mainType == "S") {
            switch (res.data.summaryInfo.main_file_url) {
              case "https://kr.object.ncloudstorage.com/itmsugang/main/global_main5.jpg":
                this.selectSampleMain = "5";
                this.main_file_url =
                  "https://kr.object.ncloudstorage.com/itmsugang/main/global_main5.jpg";
                break;
              case "https://kr.object.ncloudstorage.com/itmsugang/main/global_main4.jpg":
                this.selectSampleMain = "4";
                this.main_file_url =
                  "https://kr.object.ncloudstorage.com/itmsugang/main/global_main4.jpg";
                break;
              case "https://kr.object.ncloudstorage.com/itmsugang/main/global_main3.jpg":
                this.selectSampleMain = "3";
                this.main_file_url =
                  "https://kr.object.ncloudstorage.com/itmsugang/main/global_main3.jpg";
                break;
              case "https://kr.object.ncloudstorage.com/itmsugang/main/global_main2.jpg":
                this.selectSampleMain = "2";
                this.main_file_url =
                  "https://kr.object.ncloudstorage.com/itmsugang/main/global_main2.jpg";
                break;
              case "https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg":
                this.selectSampleMain = "1";
                this.main_file_url =
                  "https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg";
                break;
            }
          }

          this.main_file_url = res.data.summaryInfo.main_file_url;

          if (this.logoType === "F") {
            this.selectedLogoFileName =
              res.data.summaryInfo.company_logo_file_name;
          } else if (this.logoType === "S") {
            if (res.data.summaryInfo.company_logo_file_url) {
              this.company_logo_file_url =
                res.data.summaryInfo.company_logo_file_url;
              this.defaultLogoUrl = this.company_logo_file_url;
            } else {
              this.company_logo_file_url =
                "https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png";
              this.defaultLogoUrl =
                "https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png";
            }
          }

          if (res.data.summaryInfo.company_logo_file_url) {
            this.company_logo_file_url =
              res.data.summaryInfo.company_logo_file_url;
            this.defaultLogoUrl = this.company_logo_file_url;
          }

          this.qaAdminInfo = res.data.summaryInfo.qa_admin_info;
          this.qaAdmin = res.data.summaryInfo.qa_admin;
          this.idxItmSugangCompany =
            res.data.summaryInfo.idx_itm_sugang_company;

          if (
            res.data.summaryInfo.qa_admin_info &&
            res.data.summaryInfo.qa_admin &&
            res.data.summaryInfo.qa_admin_idx
          ) {
            let infoSplit = res.data.summaryInfo.qa_admin_info.split("^");
            let idxSplit = res.data.summaryInfo.qa_admin_idx.split("/");
            let adminSplit = res.data.summaryInfo.qa_admin.split("^");
            for (let i = 0; i < idxSplit.length; i++) {
              /**
               * rowType : 1 => 수정불가능
               * rowType : 2 => 신규건이라 수정가능
               */
              const qaInfoObj = {
                qaAdmin: adminSplit[i],
                qaAdminIdx: idxSplit[i],
                qaAdminInfo: infoSplit[i],
                rowType: 1,
              };

              this.qaList.push(qaInfoObj);
            }
          }

          if (res.data.summaryInfo.download_file1_url)
            this.download_file1_url = res.data.summaryInfo.download_file1_url;
          if (res.data.summaryInfo.download_file2_url)
            this.download_file2_url = res.data.summaryInfo.download_file2_url;
          if (res.data.summaryInfo.download_file3_url)
            this.download_file3_url = res.data.summaryInfo.download_file3_url;
          if (res.data.summaryInfo.download_file1_name)
            this.downloadFile1Name = res.data.summaryInfo.download_file1_name;
          if (res.data.summaryInfo.download_file2_name)
            this.downloadFile2Name = res.data.summaryInfo.download_file2_name;
          if (res.data.summaryInfo.download_file3_name)
            this.downloadFile3Name = res.data.summaryInfo.download_file3_name;
          if (res.data.summaryInfo.is_download1)
            this.isDownload1 = res.data.summaryInfo.is_download1;
          else this.isDownload1 = "N";
          if (res.data.summaryInfo.is_download2)
            this.isDownload2 = res.data.summaryInfo.is_download2;
          else this.isDownload2 = "N";
          if (res.data.summaryInfo.is_download3)
            this.isDownload3 = res.data.summaryInfo.is_download3;
          else this.isDownload3 = "N";

          if (res.data.summaryInfo.is_swipe)
            this.isSwipe = res.data.summaryInfo.is_swipe;
          else this.isSwipe = "N";
          if (res.data.summaryInfo.swipe1_url)
            this.swipe_file1_url = res.data.summaryInfo.swipe1_url;
          if (res.data.summaryInfo.swipe2_url)
            this.swipe_file2_url = res.data.summaryInfo.swipe2_url;
          if (res.data.summaryInfo.swipe3_url)
            this.swipe_file3_url = res.data.summaryInfo.swipe3_url;

          this.sugang_always_signup_YN =
            res.data.summaryInfo.sugang_always_signup_YN; //수강 상시신청 여부

          this.axios
            .get(this.axios.root + this.axios.port + "/admin/list")
            .then((res) => {
              if (res.data.err === 0) {
                this.hqManagers = res.data.hqList;
                for (var manager of this.hqManagers) {
                  if (manager.name === this.hqNameMng) {
                    this.idxItmSugangEmpMng = Number(manager.regid);
                    this.selectHqManager = manager;
                    this.qaAdminData = manager;
                  }
                }
                // 신청개요 불러오기로 호출한 경우 처음 고객사코드 중복체크 된걸로 처리
                this.isCheckedOverlap = true;
              } else {
                alert(res.data.result);
              }
            })
            .catch((err) => {
              console.log("err", err);
              alert(err);
            });
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    } else {
      this.defaultLogoUrl =
        "https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png";
      this.company_logo_file_url = this.defaultLogoUrl;
      this.startEvalDate = this.formatDate();
      this.endEvalDate = this.formatDate();
      this.loginIdxItmSugangEmpMng = localStorage.getItem("regid");
      this.axios
        .get(this.axios.root + this.axios.port + "/admin/list")
        .then((res) => {
          if (res.data.err === 0) {
            this.hqManagers = res.data.hqList;
            for (var manager of this.hqManagers) {
              if (manager.regid === Number(this.loginIdxItmSugangEmpMng)) {
                this.idxItmSugangEmpMng = Number(this.loginIdxItmSugangEmpMng);
                this.selectHqManager = manager;
                this.qaAdminData = manager;
                this.hqNameMng = manager.name;
                this.addClassQna();
              }
            }
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          console.log("err", err);
          alert(err);
        });
    }
  },

  watch: {
    // 중복 체크하고 다시 고객사 코드 변경시 재 체크하기 위함
    companyCode() {
      if (sessionStorage.getItem("fix")) {
      }
      this.isCheckedOverlap = false;
    },

    mainType() {
      if (this.mainType === "S") {
        this.main_file_url =
          "https://kr.object.ncloudstorage.com/itmsugang/main/global_main1.jpg";
      } else if (this.mainType === "N") {
        this.main_file_url = "";
      }
    },

    logoType() {
      if (this.logoType === "S") {
        if (this.company_logo_file_url === "") {
          this.defaultLogoUrl =
            "https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png";
          this.company_logo_file_url = this.defaultLogoUrl;
        }
      } else if (this.logoType === "N") {
        this.company_logo_file_url = "";
        this.defaultLogoUrl = "";
      }
    },
  },

  methods: {
    regSampleMain(url, index) {
      this.selectSampleMain = index;
      this.main_file_url = url;
    },

    // 이전 페이지 이동
    prev() {
      this.$router.push("/admin/reg/init");
    },

    // 다음 페이지 이동
    async next() {
      if (this.isSaved) {
        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
        var idx = pOrder.indexOf("input") + 1;
        sessionStorage.setItem("step", pOrder[idx]);
        this.$router.push(`/admin/reg/${pOrder[idx]}`);
      } else {
        alert("저장을 먼저 해주세요.");
        return false;
      }
    },

    // HQ매니저 select 변경시 HQ매니저 이름, idx 같이 변경
    changeHQManager(data) {
      this.hqNameMng = data.name;
      this.idxItmSugangEmpMng = data.regid;
    },

    // 수강신청 문의 추가
    addClassQna() {
      if (this.qaAdminData === "") {
        alert("매니저를 선택해주세요.");
        return false;
      } else {
        var info =
          "캐럿글로벌 " +
          this.qaAdminData.name +
          "매니저" +
          " / " +
          this.qaAdminData.cellphone +
          " / " +
          this.qaAdminData.email;
        this.qaList.push({
          qaAdmin: this.qaAdminData.name,
          qaAdminIdx: this.qaAdminData.regid,
          qaAdminInfo: info,
          rowType: 2,
        });
        this.mappingClassQna();
      }
    },

    // 수강신청 문의 삭제
    delClassQna(index) {
      this.qaList.splice(index, 1);
      this.mappingClassQna();
    },

    // 수강신청에서 받은 qaList 데이터를 String 파라미터형식에 맞게 변환
    // qaAdmin: 수강신청 문의 추가 매니저(^로 구분)
    // qaAdminIdx: 수강신청 문의 추가 매니저(^로 구분)
    // qaAdminInfo: 수강신청 문의 매니저 정보(^로 구분)
    mappingClassQna() {
      if (this.qaList.length === 0) {
        this.qaAdmin = "";
        this.qaAdminIdx = "";
        this.qaAdminInfo = "";
      } else {
        var qaAdminList = [];
        var qaAdminIdxList = [];
        var qaAdminInfoList = [];
        for (var item of this.qaList) {
          qaAdminList.push(item.qaAdmin);
          qaAdminIdxList.push(item.qaAdminIdx);
          qaAdminInfoList.push(item.qaAdminInfo);
        }

        this.qaAdmin = qaAdminList.join("^");
        this.qaAdminIdx = qaAdminIdxList.join("/");
        this.qaAdminInfo = qaAdminInfoList.join("^");
      }
    },

    preview() {
      if (!this.isSaved) {
        alert("미리보기를 하려면 먼저 저장을 해야합니다.");
        return false;
      }
      window.open(this.axios.preview + "/link/" + this.companyCode);
    },

    // 임시 저장
    async save() {
      if (this.isFetching) {
        alert("저장중입니다...");
        return false;
      }

      if (!EmptyCheck(this.companyNameDirect, "고객사 혹은 고객사 직접입력")) {
        return false;
      }

      if (
        !(
          this.overlapCompanyCode === this.companyCode &&
          this.overlapCompanyCode !== ""
        )
      ) {
        if (!this.isCheckedOverlap) {
          alert("고객사 코드 중복 확인을 해주세요.");
          return false;
        }
      }

      if (this.startEvalDate === "") {
        alert("수강신청 시작기간을 선택해주세요.");
        return false;
      }

      if (this.endEvalDate === "") {
        alert("수강신청 종료기간을 선택해주세요.");
        return false;
      }

      if (this.accessCode.trim() === "") {
        alert("AccessCode를 입력해주세요.");
        return false;
      }

      let formData = new FormData();

      formData.append(
        "idxItmSugangPageMain",
        sessionStorage.getItem("pageIdx")
      );
      formData.append("accessCode", this.accessCode);
      formData.append("accessCodePass", this.accessCodePass);
      formData.append("cancleYn", this.cancleYn);
      formData.append("companyCode", this.companyCode);
      formData.append("companyNameDirect", this.companyNameDirect);
      formData.append("infoMessage", this.infoMessage);
      formData.append("mainType", this.mainType);
      formData.append("logoType", this.logoType);
      formData.append("managerYn", this.managerYn);
      formData.append("lmsView", this.lmsView);
      formData.append("pointColor", this.pointColor);
      formData.append("programDupYn", this.programDupYn);
      formData.append("applyResultAlarmYn", this.applyResultAlarmYn);
      formData.append("limitWay", this.limitWay);
      formData.append("limitNum", this.limit_num);
      formData.append("waitYn", this.wait_YN);
      formData.append("waitNum", this.wait_num);
      formData.append("waitNumYn", this.wait_num_YN);

      //수강 상시 신청 여부
      formData.append("sugangAlwaysSignupYN", this.sugang_always_signup_YN);

      sessionStorage.setItem("programDupYn", this.programDupYn);
      sessionStorage.setItem("applyResultAlarmYn", this.applyResultAlarmYn);
      sessionStorage.setItem("limit_way", this.limitWay);
      // HQ매니저
      formData.append("hqNameMng", this.hqNameMng);
      formData.append("idxItmSugangEmpMng", this.idxItmSugangEmpMng);

      // 수강신청 문의 매니저
      this.mappingClassQna();
      formData.append("qaAdmin", this.qaAdmin);
      formData.append("qaAdminInfo", this.qaAdminInfo);
      formData.append("qaAdminIdx", this.qaAdminIdx);

      console.log("qa");
      console.log(this.qaList);
      console.log(this.qaList.length);
      console.log(this.qaAdminIdx);
      console.log(formData);

      if (sessionStorage.getItem("fix")) {
        formData.append("mainIdx", this.idx);
      } else {
        if (this.idx !== -1) {
          formData.append("mainIdx", this.idx);
        } else {
          formData.append("mainIdx", this.idx);
        }
      }

      formData.append("idxItmSugangCompany", this.idxItmSugangCompany);
      formData.append("sugangName", this.sugangName);

      if (this.main_file_url !== "") {
        formData.append("mainFileUrl", this.main_file_url);
      }

      if (this.selectedMainFileName !== "") {
        formData.append("mainFileName", this.selectedMainFileName);
      }

      if (this.company_logo_file_url !== "") {
        formData.append("companyLogoFileNameUrl", this.company_logo_file_url);
      }

      if (this.selectedLogoFileName !== "") {
        formData.append("companyLogoFileName", this.selectedLogoFileName);
      }

      if (typeof this.startEvalDate === "object") {
        formData.append(
          "sugangStartDate",
          this.startEvalDate.toISOString().slice(0, 10) +
            " " +
            this.starthh +
            ":" +
            this.startmm
        );
      } else {
        formData.append(
          "sugangStartDate",
          this.startEvalDate + " " + this.starthh + ":" + this.startmm
        );
      }

      if (typeof this.endEvalDate === "object") {
        formData.append(
          "sugangEndDate",
          this.endEvalDate.toISOString().slice(0, 10) +
            " " +
            this.endhh +
            ":" +
            this.endmm
        );
      } else {
        formData.append(
          "sugangEndDate",
          this.endEvalDate + " " + this.endhh + ":" + this.endmm
        );
      }

      if (this.mainType === "F") {
        if (this.completeMainFile !== "") {
          formData.append("mainFile", this.completeMainFile);
        } else {
          if (!sessionStorage.getItem("fix")) {
            alert("메인 배경 파일 첨부를 해주세요.");
            return false;
          } else {
            formData.append("mainFile", new Blob(), "");
          }
        }
      } else {
        formData.append("mainFile", new Blob(), "");
      }

      if (this.logoType === "F") {
        if (this.completeLogoFile !== "") {
          formData.append("logoFile", this.completeLogoFile);
        } else {
          if (!sessionStorage.getItem("fix")) {
            alert("로고 파일 첨부를 해주세요.");
            return false;
          } else {
            formData.append("logoFile", new Blob(), "");
          }
        }
      } else {
        formData.append("logoFile", new Blob(), "");
      }

      this.overlapCompanyCode = this.companyCode;

      // 다운로드 사용여부 private String isDownload1, isDownload2, isDownload3;

      //다운로드 파일1, 2, 3
      formData.append("downloadFile1Name", this.downloadFile1Name);
      formData.append("downloadFile2Name", this.downloadFile2Name);
      formData.append("downloadFile3Name", this.downloadFile3Name);
      formData.append("downloadFile1Url", this.download_file1_url);
      formData.append("downloadFile2Url", this.download_file2_url);
      formData.append("downloadFile3Url", this.download_file3_url);

      formData.append("isDownload1", this.isDownload1);
      formData.append("isDownload2", this.isDownload2);
      formData.append("isDownload3", this.isDownload3);

      //스와이프 파일1, 2, 3
      formData.append("isSwipe", this.isSwipe);
      formData.append("swipeFile1Url", this.swipe_file1_url);
      formData.append("swipeFile2Url", this.swipe_file2_url);
      formData.append("swipeFile3Url", this.swipe_file3_url);

      let headers = {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "multipart/form-data",
      };

      if (sessionStorage.getItem("fix") || this.isSaved) {
        await this.axios
          .put(
            this.axios.root + this.axios.port + "/sugang/summary",
            formData,
            headers
          )
          .then((res) => {
            console.log("res", res);
            if (res.data.err === 0) {
              alert(res.data.result);
              this.isSaved = true;
              sessionStorage.setItem("mainIdx", this.idx);
            } else {
              alert(res.data.result);
              return;
            }
          })
          .catch((err) => {
            console.log(err);
            alert(err);
          });
      } else {
        this.isFetching = true;
        await this.axios
          .post(
            this.axios.root + this.axios.port + "/sugang/summary",
            formData,
            headers
          )
          .then((res) => {
            console.log("res", res);
            this.isFetching = false;
            if (res.data.err === 0) {
              alert("저장되었습니다.");
              this.isSaved = true;
              this.idx = res.data.mainIdx;
              sessionStorage.setItem("mainIdx", res.data.mainIdx);
            } else {
              alert(res.data.message);
              return;
            }
          })
          .catch((err) => {
            this.isFetching = false;
            console.log(err);
            alert(err);
          });
      }
    },

    // 고객사 고유 코드 중복확인
    checkOverlap() {
      var params = {
        code: this.companyCode,
      };
      this.axios
        .get(this.axios.root + this.axios.port + "/sugang/code-check", {
          params: params,
        })
        .then((res) => {
          console.log("res", res);
          if (res.data.err === 0) {
            this.isCheckedOverlap = true;
            alert(res.data.result);
          } else {
            alert(res.data.result);
          }
        });
    },

    // 검색 모달 열기
    openModal() {
      this.isModalOpened = true;
    },

    // 검색 모달 닫기
    closeModal() {
      this.isModalOpened = false;
    },

    // 고객사 검색 팝업에서 데이터 가져옴
    selectCompany(company, regid) {
      this.companyName = company;
      this.companyNameDirect = company;
      this.idxItmSugangCompany = regid;

      var params = {
        idx: this.idxItmSugangCompany,
      };

      // 해당 고객사 로고 가져오기
      this.axios
        .get(this.axios.root + this.axios.port + "/sugang/company-logo", {
          params: params,
        })
        .then((res) => {
          console.log("res", res);
          if (res.data.err === 0) {
            this.defaultLogoUrl = res.data.logo.file_url;
          } else {
            this.defaultLogoUrl = "";
          }
        });
      this.isModalOpened = false;
    },

    // 로고 파일 선택 로직
    selectLogoFile(event) {
      this.selectedLogoFiles = this.$refs.file.files;
      var allowFormat = ["pdf", "jpg", "jpeg", "png", "gif"];
      var checked = false;
      for (var item of allowFormat) {
        if (this.selectedLogoFiles[0].name.includes(item)) {
          checked = true;
          break;
        } else {
          continue;
        }
      }
      if (checked) {
        console.log("event", event);
        let file = event.target.files[0];

        if (event.target.files[0].size > 1048576) {
          alert("1MB 이하만 업로드 가능합니다.");
          this.$refs.file.value = "";
          this.selectedLogoFiles = "";
          return false;
        }

        this.completeLogoFile = event.target.files[0];
        this.selectedLogoFileName = event.target.files[0].name;
        let formData = new FormData();
        formData.append("file", file);

        this.$refs.file.value = "";
      } else {
        alert("파일 포맷은 pdf, jpg, jpeg, png, gif형식만 가능합니다.");
        this.$refs.file.value = "";
        this.selectedLogoFiles = "";
        return false;
      }
    },

    // 메인 파일 선택 로직
    selectMainFile(event) {
      this.selectedMainFiles = this.$refs.mainfile.files;
      var allowFormat = ["pdf", "jpg", "jpeg", "png", "gif"];
      var checked = false;
      for (var item of allowFormat) {
        if (this.selectedMainFiles[0].name.includes(item)) {
          checked = true;
          break;
        } else {
          continue;
        }
      }
      if (checked) {
        console.log("event", event);
        let file = event.target.files[0];
        console.log("file", file);

        if (event.target.files[0].size > 1048576) {
          alert("1MB 이하만 업로드 가능합니다.");
          this.$refs.mainfile.value = "";
          this.selectedLogoFiles = "";
          return false;
        }

        this.completeMainFile = event.target.files[0];
        this.selectedMainFileName = event.target.files[0].name;

        this.$refs.mainfile.value = "";
        // 등록되어있는 url 초기화
        this.main_file_url = "";
      } else {
        alert("파일 포맷은 pdf, jpg, jpeg, png, gif형식만 가능합니다.");
        this.$refs.mainfile.value = "";
        this.selectedMainFiles = "";
        return false;
      }
    },
    selectUploadFile(event, type) {
      let file = event.target.files[0];
      if (event.target.files[0].size > 2097152) {
        alert("2MB 이하만 업로드 가능합니다.");
        return false;
      }

      //download 1,2,3
      if (type == "downloadFile1") {
        this.selectedDownloadFile1Name = event.target.files[0].name;
        this.$refs.downloadFile1.value = "";
        this.download_file1_url = "";
      } else if (type == "downloadFile2") {
        this.selectedDownloadFile2Name = event.target.files[0].name;
        this.$refs.downloadFile2.value = "";
        this.download_file2_url = "";
      } else if (type == "downloadFile3") {
        this.selectedDownloadFile3Name = event.target.files[0].name;
        this.$refs.downloadFile3.value = "";
        this.download_file3_url = "";
      }
      //swipe 1,2,3
      else if (type == "swipeFile1") {
        this.selectedSwipeFile1Name = event.target.files[0].name;
        this.$refs.swipeFile1.value = "";
        this.swipe_file1_url = "";
      } else if (type == "swipeFile2") {
        this.selectedSwipeFile2Name = event.target.files[0].name;
        this.$refs.swipeFile2.value = "";
        this.swipe_file2_url = "";
      } else if (type == "swipeFile3") {
        this.selectedSwipeFile3Name = event.target.files[0].name;
        this.$refs.swipeFile3.value = "";
        this.swipe_file3_url = "";
      }

      // 업로드
      let formData = new FormData();
      formData.append("file", file);
      this.axios
        .post(
          this.axios.root + this.axios.port + "/upload/download",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then((res) => {
          if (res.data.status === 0) {
            // download 1,2,3
            if (type == "downloadFile1") {
              this.download_file1_url = res.data.result;
            } else if (type == "downloadFile2") {
              this.download_file2_url = res.data.result;
            } else if (type == "downloadFile3") {
              this.download_file3_url = res.data.result;
            }
            //swipe 1,2,3
            else if (type == "swipeFile1") {
              this.swipe_file1_url = res.data.result;
            } else if (type == "swipeFile2") {
              this.swipe_file2_url = res.data.result;
            } else if (type == "swipeFile3") {
              this.swipe_file3_url = res.data.result;
            }
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    // 시간, 분 한자리일때 0 추가
    plusZero(time) {
      if (time.length === 1) {
        return "0" + time;
      } else {
        return time;
      }
    },

    // CK에디터에 기본 문구 삽입
    insertDefaultTag() {
      this.infoMessage =
        '<p><span style="font-weight: bold">수강 신청 기간 |</span> 1/28()</p> <p><span style="font-weight: bold">수강 신청 기간 |</span> 1/28(화) ~ 2/6 (목)</p> <p><span style="font-weight: bold">사전 레벨테스트 기간 |</span> 2/3(월) ~ 2/7(금)</p> <p><span style="font-weight: bold">과정 준비 및 안내 |</span> 2/10(월) ~ 2/21(금)</p> <p><span style="font-weight: bold">과정 오픈 |</span> 2/25(화) & 2/26(수)</p> <p><span style="font-weight: bold">과정 기간 |</span> 2월 25일 화요일 ~ 4월 16일 목요일 <br> 2월 26일 수요일 ~ 4월 22일 수요일 (8주, 16회)</p> <p><span style="font-weight: bold">시간 |</span> 화,목 11:40~12:30 또는 수,금 11:40~12:30 (1시간)</p> <p><span style="font-weight: bold">수료기준 |</span> 출석률 80% 달성</p>';
    },

    // 오늘 날짜 YYYY-MM-DD로 지정하는 함수\
    formatDate() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    // 수강 신청 기간 사용 유무
    is_sugang_date() {
      return this.sugang_always_signup_YN == "N" ? true : false;
    },
  },
};
</script>

<style>
input:disabled {
  background-color: #eee;
}
.preview-img {
  width: 114px;
  height: 70px;
  background: #e9e9e9e9;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
